// jQuery and Popper.js loaded in config/webpack/environment.js
import '@popperjs/core';
import 'bootstrap';

import 'jquery-ujs';
// import 'tablesorter';
// import 'scroll-depth';

import '../utilities/form_remote_checkbox';
import '../utilities/jquery_put_cursor_at_end';
import '../utilities/shirts_countdown';

import '../controllers/application';

$(() => {
  $('[data-bs-toggle="tooltip"]').tooltip();
  $('[data-bs-toggle="popover"]').popover();

  // $.scrollDepth({
  //   elements: ['#footer'],
  // });
  //
  // $('.tablesorter').tablesorter({
  //   textAttribute: 'data-sort-value',
  // });
});
